import { Capacitor } from "@capacitor/core";
export const getPresignedPutUrlHost = (putUrl) => {
    try {
        return new URL(putUrl).hostname;
    }
    catch {
        return "";
    }
};
/**
 * PUT del archivo a una URL prefirmada (p. ej. S3). En app Capacitor, con
 * `CapacitorHttp.enabled: true` en capacitor.config, XHR suele ir por la pila
 * nativa y evita bloqueos CORS del WebView (origen https://localhost).
 */
const putFileToPresignedUrl = async (putUrl, file, contentType, onProgress) => {
    return new Promise((resolve, reject) => {
        try {
            const host = getPresignedPutUrlHost(putUrl);
            const xhr = new XMLHttpRequest();
            xhr.open("PUT", putUrl);
            xhr.setRequestHeader("Content-Type", contentType);
            xhr.timeout = 180000;
            xhr.upload.onprogress = (event) => {
                if (!event.lengthComputable || typeof onProgress !== "function")
                    return;
                const pct = Math.min(99, Math.round((event.loaded / event.total) * 100));
                onProgress(pct);
            };
            xhr.onload = () => {
                resolve({
                    ok: xhr.status >= 200 && xhr.status < 300,
                    status: xhr.status,
                    statusText: xhr.statusText || "",
                });
            };
            xhr.onerror = () => {
                const native = Capacitor.isNativePlatform();
                reject(new Error([
                    "Fallo de red al subir al almacenamiento.",
                    host ? `Servidor: ${host}.` : "",
                    `Tamaño archivo: ${file.size} bytes.`,
                    native
                        ? "Si usas la app instalada: suele ser bloqueo CORS del almacenamiento hacia el WebView; con HTTP nativo de Capacitor activado debería resolverse. Prueba WiFi o datos móviles."
                        : "Si persiste, prueba WiFi u otro navegador.",
                ]
                    .filter(Boolean)
                    .join(" ")));
            };
            xhr.ontimeout = () => {
                reject(new Error(`Tiempo agotado al subir${host ? ` (${host})` : ""}. Prueba un archivo más liviano u otra red.`));
            };
            xhr.onabort = () => reject(new Error("Subida cancelada."));
            xhr.send(file);
        }
        catch (e) {
            reject(e);
        }
    });
};
export default putFileToPresignedUrl;
